import React, { useEffect } from 'react';
import { useDatingHistory } from './hooks/DatingHistory.hook';
import { useSelector } from 'react-redux';
import DatingHistoryView from './views/DatingHistoryView';
import LoadingComponent from '@/components/general/Loading/LoadingComponent';

const DatingHistoryController = () => {
  const lenguage = useSelector(state => state.lenguage?.lang);

  const {
    isLoading,
    reportData,
    error,
    saveMedicalHistory,
  } = useDatingHistory();

  if (isLoading) {
    return <LoadingComponent loading={isLoading} />;
  } else {
    return (
      <DatingHistoryView
        lenguage={lenguage}
        error={error}
        reportData={reportData}
        saveMedicalHistory={saveMedicalHistory}
      />
    );
  }
};

export default DatingHistoryController;
